import {
	CloseButton,
	Popover,
	PopoverBackdrop,
	PopoverButton,
	PopoverPanel,
} from '@headlessui/react'
import { Bars3Icon } from '@heroicons/react/20/solid'
import { Link, useLocation } from '@remix-run/react'

const NavigationItem = ({
	name,
	to,
	isActive,
	onClick,
}: {
	name: string
	to: string
	isActive: boolean
	onClick?: () => any
}) => {
	return (
		<div
			className={`${isActive ? 'font-semibold text-slate-300' : 'text-slate-500'}`}
			onClick={onClick}
		>
			<CloseButton as={Link} to={to}>
				{name}
			</CloseButton>
		</div>
	)
}

export default function TopNavigation() {
	const location = useLocation()
	return (
		<div className="flex w-full justify-center">
			<div className="flex max-w-[700px] flex-1 items-center">
				<div className="absolute">
					<Popover className="group">
						<PopoverButton className="flex items-center data-[closed]:rotate-180">
							<Bars3Icon width={'2rem'} height={'2rem'} />
						</PopoverButton>
						<PopoverBackdrop
							transition
							className="fixed left-0 top-0 z-10 h-screen w-screen transition-all data-[open]:backdrop-blur-sm"
							id="testing"
						/>
						<PopoverPanel
							transition
							anchor="bottom start"
							className="flex min-w-[200px] flex-col gap-y-8 rounded-xl bg-black p-4 py-8 pr-6 text-xl transition duration-200 ease-in-out data-[closed]:-translate-y-1 data-[closed]:opacity-0"
						>
							<NavigationItem name="Home" to="/" isActive={location.pathname === '/'} />
							<NavigationItem
								name="Search"
								to="/select/search"
								isActive={location.pathname === '/select/search'}
							/>
							<NavigationItem
								name="Compare"
								to="/select/submit"
								isActive={location.pathname === '/select/submit'}
							/>
							<NavigationItem
								name="Statistics"
								to="/statistics"
								isActive={location.pathname === '/statistics'}
							/>
							<NavigationItem
								name="Leaderboard"
								to="/leaderboard"
								isActive={location.pathname === '/leaderboard'}
							/>
							<NavigationItem name="Races" to="/races" isActive={location.pathname === '/races'} />
							<NavigationItem name="About" to="/about" isActive={location.pathname === '/about'} />
						</PopoverPanel>
					</Popover>
				</div>
				<div className="w-full text-center text-h5">MarathonRank</div>
			</div>
		</div>
	)
}
